import React from 'react';

function TestimonialItem3(props) {
    return (
        <div className="col-lg-6">               
            <div className="testimonial-item">            
                <p>
                <span className='i-quote'>"</span> {props.text}<span className='i-quote'>"</span>
                <br></br>
                <a href="https://www.nieuwsblad.be/cnt/dmf20210617_95180115" rel="noreferrer" target="_blank">{props.link}</a>
                </p>
                <p className="text-sombre"># {props.source}<br></br><span className="text-sombre">{props.date}</span></p>            
            </div>        
        </div> 
    )
}

export default TestimonialItem3;
